import Scheduler from '../components/appointment/Scheduler'

function Clinic() {
	return (
		<div>
			<h1 className="header-g">Clinic</h1>
			<Scheduler />
		</div>
	)
}

export default Clinic
